import UserRepository from "@domain/repositories/UserRepository";
import UseCase from "@domain/UseCase";
import { User } from "@domain/models/User";

type Input = User["id"];

type Output = Promise<void>;

export class DeleteUserUseCase implements UseCase<Input, Output> {
  constructor(private readonly userRepository: UserRepository) {}

  execute(userId: Input) {
    return this.userRepository.delete(userId);
  }
}
